export const TRIP_DURATION_MARGIN = 60000;
